import React, { Component } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import Blank from '../../hoc/Blank/Blank';
import Table from '../../components/UI/Table/Table';
import Spinner from '../../components/UI/Spinner/Spinner';
import * as actions from '../../store/actions/index';
import 'react-toastify/dist/ReactToastify.min.css';
import { ToastContainer, toast } from 'react-toastify';

let deleting = false;
let orderId = 0;
class AdminScoutSummary extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
    this.props.onFetchScoutSummary();
  }

  componentDidUpdate(prevProps) {
  }

  showUser = (e) => {
    let oid = e.currentTarget.getAttribute('oid');
    this.props.history.push('/adminOrders?' + oid);
  }

  state = {
    userId: 0,
  }



  render() {
    if (!this.props.loading && this.props.scoutSummary) {
      var data = [];
      let pl = "30px";
      let fifty = "50px";
      let oneFifty = "150px";
      let seventyFive = "75px";

      if (window.innerWidth < 500) {
        pl = "5px";
        fifty = "40px";
        oneFifty = "100px";
        seventyFive = "50px";
      }
 
      let i = -1;
      for (let k in this.props.scoutSummary) {
        let sum = this.props.scoutSummary[k];        
          i = i + 1;
          data.push({
            oid: sum.userId, data: [{
              value: sum.userId,
              style: { paddingLeft: pl, width: seventyFive },
              full: false
            },
            {
              value: sum.scout,
              style: { width: oneFifty, paddingLeft: pl },
              full: false
            }
            
            ]
          }
          )

          if (this.props.mulchYear.sellHardwood) {
            data[i].data.push(
              {
                value: sum.hardwoodBags,
                style: { width: fifty, paddingLeft: pl },
                full: false
              }
            );
          }
          if (this.props.mulchYear.sellCedar) {
            data[i].data.push(
              {
                value: sum.cedarBags,
                style: { width: fifty, paddingLeft: pl },
                full: false
              }    
            );
          }
          if (this.props.mulchYear.sellBlack) {
            data[i].data.push(
              {
                value: sum.blackBags,
                style: { width: fifty, paddingLeft: pl },
                full: false
              }
            );
          }
          if (this.props.mulchYear.sellRed) {
            data[i].data.push(
              {
                value: sum.redBags,
                style: { width: fifty, paddingLeft: pl },
                full: false
              }
            );
          }
          data[i].data.push(
            {
              value: sum.totalBags,
              style: { width: fifty, paddingLeft: pl },
                full: false
            }
          )
        }


      var header = [{
        name: "User Id",
        sort: "",
        style: { paddingLeft: pl, width: seventyFive }
      },
      {
        name: "Scout",
        sort: "",
        style: { width: oneFifty, paddingLeft: pl }
      }
    ];

    if (this.props.mulchYear.sellHardwood) {
      header.push(
      {
        name: "Hwd",
        style: { width: fifty, paddingLeft: pl }
      })
    }

    if (this.props.mulchYear.sellCedar) {
      header.push(
      {
        name: "Cdr",
        style: { width: fifty, paddingLeft: pl }
      })
    }

    if (this.props.mulchYear.sellBlack) {
      header.push(
      {
        name: "Blk",
        style: { width: fifty, paddingLeft: pl }
      })
    }

    if (this.props.mulchYear.sellRed) {
      header.push(
      {
        name: "Red",
        style: { width: fifty, paddingLeft: pl }
      })
    }
    header.push(
      {
        name: "Total",
        style: { width: fifty, paddingLeft: pl }
      })

      return (

        <Blank>
          <ToastContainer autoClose={3000} />
          <Table header={header} data={data} editPopupHandler={this.showUser}></Table>
        </Blank>
      );
    }
    else {
      return (
        <div>
          <Spinner />
        </div>
      );
    }
  }
}

const mapStateToProps = state => {
  return {
    mulchYear: state.orders.mulchYear,
    scoutSummary: state.orders.scoutSummary,
    loading: state.orders.loading
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onFetchScoutSummary: () => dispatch(actions.fetchScoutSummary())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AdminScoutSummary);


// WEBPACK FOOTER //
// ./src/containers/adminScoutSummary/adminScoutSummary.js